import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateMultipleImagePostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.updateImagePost,
  {
    mutationKey: ['updateMultipleImagePost'],
  },
)
